
import { admin } from './admin.js'
import { connexion } from "./connexion.js";

export const routes = [
  ...admin,
  ...connexion,

  // { path: '*', beforeEnter: (to, from, next) => { next('/404') } }
];

